"use strict";
var sdk_1 = require("./sdk");
Object.assign(module.exports, sdk_1.Personalize);
module.exports = sdk_1.Personalize;
//# sourceMappingURL=index.js.map